import { SEARCH_POPULATION_ENDPOINT } from '../../../../../../../common/config/api_endpoints';
import createAmplifyAPICallEpic from '../../../../../../../redux/epics/utils';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../../redux/actions/action_utils';
import { extractTableDataFromPayload } from '../../../../../../../common/components/table/utils/table_redux_payload_utils';

const SEARCH_CONTRACT_POPULATION_ACTION_TYPES = createAPILifecycleActionTypes(
  'SEARCH_CONTRACT_POPULATION_ACTION_TYPES',
);
export const searchContractPopulationActions = createAPILifecycleActions(
  SEARCH_CONTRACT_POPULATION_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_CONTRACT_POPULATION_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case SEARCH_CONTRACT_POPULATION_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          ...state.data,
          ...extractTableDataFromPayload(payload),
        },
        error: null,
      };
    case SEARCH_CONTRACT_POPULATION_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case SEARCH_CONTRACT_POPULATION_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const searchContractPopulationEpic = createAmplifyAPICallEpic({
  actionType: SEARCH_CONTRACT_POPULATION_ACTION_TYPES.BEGIN,
  api: SEARCH_POPULATION_ENDPOINT,
  successCallback: response => [searchContractPopulationActions.SUCCESS(response.body)],
  errorCallback: () => [searchContractPopulationActions.FAILURE()],
});
